import classnames from 'classnames';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import * as api from '../../api';
import NavBar, { View } from '../../components/NavBar';

import { Animation } from '../../components/Animation';
import { FormTypes } from '../../utils/form';
import { getFormsFromFormSets } from '../../utils/formSet';
import { PatientRouteParams } from '../router';
import { Content } from './Content';
import { withFetchPatient } from '../../components/hoc/withFetchPatient';
import { useFormSetsEndRedirect } from '../../hooks/form/useFormSetsEndRedirect';

import animationLoading from '../../assets/animation/loading.json';

import appStyles from '../App.module.css';
import formStyles from '../FormStart/index.module.css';
import styles from './index.module.css';

export const Recommendation: React.FC = () => {
  const { authenticationCode } = useParams<PatientRouteParams>();
  const { t } = useTranslation('recommendation');
  const { formSets, onFormSetEnd } = useFormSetsEndRedirect(
    authenticationCode,
    true,
  );
  const recommendationForms = Object.values(
    getFormsFromFormSets(formSets, FormTypes.Recommendation),
  );
  const recommendationAllCreated = recommendationForms.every(
    (form) => form.status === api.PrevisitForm.Status.Created,
  );
  const [showLoading, setShowLoading] = useState(recommendationAllCreated);
  const titles = [
    {
      text: t('analyzingPatientInfo'),
      msInterval: 1000,
    },
    { text: t('lookingForCareOpportunities'), msInterval: 1000 },
    {
      text: t('submittingYourRegistration'),
      msInterval: 1000,
    },
  ].map((title) => ({ ...title, text: t(title.text) }));
  return (
    <div className={appStyles.App}>
      <NavBar view={View.Review} />
      <div
        className={classnames(formStyles.FormContainer, {
          [styles.LoadingContainer]: showLoading,
        })}
      >
        <div className={formStyles.Form}>
          {showLoading ? (
            <Animation
              titles={titles}
              animationData={animationLoading}
              msInterval={4000}
              onIntervalEnd={() => setShowLoading(false)}
            />
          ) : (
            <Content
              authenticationCode={authenticationCode}
              recommendationForms={recommendationForms}
              t={t}
              onFormSetEnd={onFormSetEnd}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export const RecommendationPage = withFetchPatient(Recommendation);
export const RecommendationPageMulti = withFetchPatient(Recommendation, {
  multi: true,
});
